


<template lang="jade">

	div.app
		app-content

</template>









<script>



	import appHeader from './app-header.vue'
	import appContent from './app-content.vue'



	const $cmp = {
		name : 'app',
		components : {
			appHeader,
			appContent
		}
	}



	$cmp.created = function() {

		var $this = this

		let env = location.hostname

		window.Base64 = {_keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(e){var t="";var n,r,i,s,o,u,a;var f=0;e=Base64._utf8_encode(e);while(f<e.length){n=e.charCodeAt(f++);r=e.charCodeAt(f++);i=e.charCodeAt(f++);s=n>>2;o=(n&3)<<4|r>>4;u=(r&15)<<2|i>>6;a=i&63;if(isNaN(r)){u=a=64}else if(isNaN(i)){a=64}t=t+this._keyStr.charAt(s)+this._keyStr.charAt(o)+this._keyStr.charAt(u)+this._keyStr.charAt(a)}return t},decode:function(e){var t="";var n,r,i;var s,o,u,a;var f=0;e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"");while(f<e.length){s=this._keyStr.indexOf(e.charAt(f++));o=this._keyStr.indexOf(e.charAt(f++));u=this._keyStr.indexOf(e.charAt(f++));a=this._keyStr.indexOf(e.charAt(f++));n=s<<2|o>>4;r=(o&15)<<4|u>>2;i=(u&3)<<6|a;t=t+String.fromCharCode(n);if(u!=64){t=t+String.fromCharCode(r)}if(a!=64){t=t+String.fromCharCode(i)}}t=Base64._utf8_decode(t);return t},_utf8_encode:function(e){e=e.replace(/\r\n/g,"\n");var t="";for(var n=0;n<e.length;n++){var r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r)}else if(r>127&&r<2048){t+=String.fromCharCode(r>>6|192);t+=String.fromCharCode(r&63|128)}else{t+=String.fromCharCode(r>>12|224);t+=String.fromCharCode(r>>6&63|128);t+=String.fromCharCode(r&63|128)}}return t},_utf8_decode:function(e){var t="";var n=0;var r=c1=c2=0;while(n<e.length){r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r);n++}else if(r>191&&r<224){c2=e.charCodeAt(n+1);t+=String.fromCharCode((r&31)<<6|c2&63);n+=2}else{c2=e.charCodeAt(n+1);c3=e.charCodeAt(n+2);t+=String.fromCharCode((r&15)<<12|(c2&63)<<6|c3&63);n+=3}}return t}};

		window.wp = {
			url : 'https://wp.wardfour.com/wp-json/wp/v2',
			request : function(params, callback) {

				let config = {
					url : window.wp.url + params.path,
					method : params.method || 'GET',
					crossDomain : true,
					success : function (data, txtStatus, xhr) {
						if (callback) return callback(data, txtStatus, xhr)
					}
				}

				/// Use basic-auth for dev and staging envs
				/// Read-only 'staging' user
				if (env === 'localhost' || env === '2019.wardfour.com') {
					config.beforeSend = function (xhr) {
						let auth = 'Basic ' + Base64.encode('read-only:KPyNkfGi!aM2CnHD37TR@Xdl')
						xhr.setRequestHeader('Authorization', auth)
					}
				}

				$.ajax(config)

			}
		}

		if (env === 'localhost' || env === '2019.wardfour.com') {
			window.wp.status = 'any'
		} else {
			window.wp.status = 'publish'
		}

		window.stripSlashes = function(str) {
			return str.replace(/\\/g, '')
		}

		window.slugify = function(text) {
			if (!text) return ''
			return text.toString().toLowerCase().trim()
			.replace(/\s+/g, '-')           // Replace spaces with -
			.replace(/&/g, '-and-')         // Replace & with 'and'
			.replace(/[^\w\-]+/g, '')       // Remove all non-word chars
			.replace(/\-\-+/g, '-')         // Replace multiple - with single -
		}

		window.mobile = false;
		var regex = /mob|Android|webOS|iPhone|iPad|iPod|BlackBerry|BB10|IEMobile|Opera Mini/i
		if ( regex.test(navigator.userAgent) ) {
			window.mobile = true
		} else {
			window.mobile = false
		}

	}



	$cmp.mounted = function() {

		var $this = this

		$(document).ready(function() {

		})

	}



	$cmp.methods = {}

	$cmp.methods.shuffleArray = function(array) {

		var currentIndex = array.length, temporaryValue, randomIndex

		// While there remain elements to shuffle...
		while (0 !== currentIndex) {

		// Pick a remaining element...
		randomIndex = Math.floor(Math.random() * currentIndex)
		currentIndex -= 1

		// And swap it with the current element.
		temporaryValue = array[currentIndex]
			array[currentIndex] = array[randomIndex]
			array[randomIndex] = temporaryValue
		}

		return array

	}



	export default $cmp



</script>









<style lang="stylus" scoped>

	.app
		position absolute
		top 0px
		left 0px
		right 0px
		bottom 0px
		width 100%
		height 100%
		overflow hidden

</style>



// WEBPACK FOOTER //
// src/app.vue